import { setIsComplete } from "@src/@slice/bookingHallSlice";
import { getLikePartners } from "@src/api/mypage/myInterest";
import { getAdvertiseHallList } from "@src/api/weddingHall/advertise";
import { getWeddingHallRegional } from "@src/api/weddingHall/weddingHall";
import { UserContext } from "@src/App";
import AppHeader from "@src/components/common/appHeader/AppHeader";
import HorizontalPartnerList, {
  updateLikeOptimistic,
} from "@src/components/common/horizontalPartnerList/HorizontalPartnerList";
import { Blank, TooltipA } from "@src/shared/src";
import { BASE_URL, HOSTNAME, isExternalUrl, randomPick } from "@src/utils";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import NotificationArccodion from "@src/components/booking/realtimeBooking/notification/NotificationArccodion";
import styles from "./weeklyAlarmComplete.module.scss";
import dayjs from "dayjs";
import { logEvent } from "@src/reactGa";
import useUrlQueryString from "@src/utils/hooks/useUrlQueryString";

const WeeklyAlarmComplete = () => {
  const searchParams = window.location.search;
  const query = useUrlQueryString();
  const partnerUuids = query.get("partnerUuids");

  const { selectedDate, partnerName } = useLocation().state;
  const dispatch = useDispatch();

  const [aroundHallList, setAroundHallList] = useState([]);
  const [likeHallList, setLikeHallList] = useState([]);
  const [showTooltip, setShowTooltip] = useState(true);

  const formatDateListWithLineBreaks = (dateList: string[]) => {
    return dateList
      .map((date, index) => {
        const isLast = index === dateList.length - 1;
        const isThirdMultiple = (index + 1) % 3 === 0;

        if (isLast) {
          return dayjs(date).format("MM.DD");
        }

        if (isThirdMultiple) {
          return `${dayjs(date).format("MM.DD")} \n/ `;
        }

        return `${dayjs(date).format("MM.DD")} / `;
      })
      .join("");
  };
  const getAroundPartners = async () => {
    const { data } = await axios.get<{ item: { region: string }[] }>(
      `${BASE_URL}/v3/200107/partners?uuids=${partnerUuids}`,
    );
    const regions: string[] = [];
    data.item.forEach((p) => {
      const regionArr = p.region.split(" ");
      regions.push(`${regionArr[0]}-${regionArr[1]}`);
    });
    const adData = await getAdvertiseHallList("NEARBY_RECOMMEND", regions);
    getWeddingHallRegional(partnerUuids.split(","))
      .then((data) => {
        const adList = adData.item.results.map((partner) => {
          const region = `${partner.region} ${partner.subRegion}`;
          return {
            coverUrl: partner.partnerProfileImages[0].url,
            region,
            partnerUuid: partner.partnerUuid,
            partnerName: partner.partnerProfileName,
            isLiked: partner.isLike,
            isAdvertise: true,
            adCode: partner.adCode,
            adName: partner.adName,
            type: 2, // 웨딩홀
          };
        });
        const hallList = data.item.map((partner) => {
          const region = `${partner.mainRegion} ${partner.subRegion}`;
          return {
            coverUrl: partner.coverUrl,
            region,
            partnerUuid: partner.uuid,
            partnerName: partner.name,
            isLiked: partner.isLiked,
            type: 2, // 웨딩홀
          };
        });
        const randomList = randomPick(hallList, 20);
        setAroundHallList(adList.concat(randomList));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getAroundPartners();
    dispatch(setIsComplete({ bool: true })); // 완료 화면 도착정보 저장
    // 찜한 웨딩홀
    getLikePartners({ fetchSize: 100, type: 2 }).then(({ data }) => {
      const list = data.item.map((item) => {
        const splitAddress = item.address.split(" ");
        return {
          coverUrl: item.coverUrl,
          region: `${splitAddress[0]} ${splitAddress[1]}`,
          partnerUuid: item.uuid,
          partnerName: item.name,
          isLiked: item.isLiked,
          type: 2, // 웨딩홀
        };
      });
      setLikeHallList(list);
    });
  }, []);
  return (
    <div className={styles["page-weekly-alarm-complete"]}>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <h2 className={styles["title"]}>알림 신청이 완료되었습니다.</h2>
      <p className={styles["desc"]}>웨딩홀 매니저가 확인 후 연락 드릴게요.</p>
      <p className={styles["time-notice"]}>
        {`*연락 예상 시간 : 13:00 ~ 19:00
      *대표 번호 : 02-6205 로 시작`}
      </p>
      <div className={styles["noti-wrap"]}>
        <div className={styles["alarm-info-wrap"]}>
          <p className={`${styles["alarm-info-title"]}`}>알림 신청 내역</p>
          <div>
            <div className={`${styles["alarm-info-table"]}`}>
              <span>웨딩홀</span>
              <span className={`${styles["value"]}`}>{decodeURIComponent(partnerName)}</span>
            </div>
            <div className={`${styles["alarm-info-table"]}`}>
              <span>방문희망날짜</span>
              <p className={`${styles["value"]}`}>{formatDateListWithLineBreaks(selectedDate)}</p>
            </div>
          </div>
        </div>
        <NotificationArccodion isOpen={true} title={"꼭 확인해주세요."} useArccodion={false}>
          <ul className={`flex-column-wrap gap-8 ${styles["list-wrap"]}`}>
            <li style={{ listStyle: "disc" }}>
              예약 오픈 알림 신청만으로는 웨딩홀 방문 예약이 진행되지 않습니다.
            </li>
            <li style={{ listStyle: "disc" }}>
              방문 예약 신청까지 완료해 주셔야 웨딩홀 담당자가 예약 오픈일에 맞춰 방문 예약을 시도할
              수 있습니다.
            </li>
            <li style={{ listStyle: "disc" }}>예약 시도는 방문 예약 신청 순으로 진행됩니다.</li>
            <li style={{ listStyle: "disc" }}>
              원활한 안내를 위해 02-6205 번호로 시작하는 전화를 꼭 받아주시고, 부재 시 앱 채팅을
              확인해 주세요.
            </li>
          </ul>
        </NotificationArccodion>
      </div>
      <UserContext.Consumer>
        {(user) => (
          <>
            {user.me && (
              <>
                <Blank color="#f2f2f2" height={12} />
                <div style={{ padding: "40px 20px" }}>
                  <HorizontalPartnerList
                    title="이 주변 웨딩홀 추천"
                    list={aroundHallList}
                    updateLikeOptimistic={(partnerUuid) => {
                      setAroundHallList(updateLikeOptimistic(aroundHallList, partnerUuid));
                    }}
                  />
                </div>

                {likeHallList.length > 0 && (
                  <>
                    <Blank color="#f2f2f2" height={12} />
                    <div style={{ padding: "40px 20px" }}>
                      <HorizontalPartnerList
                        title="내가 찜한 웨딩홀"
                        list={likeHallList}
                        updateLikeOptimistic={(partnerUuid) => {
                          setLikeHallList(updateLikeOptimistic(likeHallList, partnerUuid));
                        }}
                      />
                    </div>
                  </>
                )}
                <Blank height={100} />
              </>
            )}
          </>
        )}
      </UserContext.Consumer>
      <div className={`btn-wrap ${styles["button-wrap"]}`}>
        <TooltipA
          isShow={showTooltip}
          content={`다음 예약 오픈일에 예약 희망 시 \n바로 신청하세요.`}
          textAlign="left"
          pointerLocation="center"
          location="right"
          close={() => setShowTooltip(false)}
          marginForCustom="0px 0px -20px -20px"
        />
        <button
          className={`btn bnt-full btn-giant btn-gray50 ${styles["complete-btn"]}`}
          onClick={() => (window.location.href = "h2mwbell://chat")}
        >
          채팅문의
        </button>
        <button
          className={`btn btn-full btn-giant btn-red500 ${styles["complete-btn"]}`}
          onClick={() => {
            logEvent("component_behavior", {
              component: "weekly_alarm_apply",
              behavior: "click",
              content: "주단위 알림 신청완료 방문예약", // + " " + partnerUuid,
              name: "주단위 알림 신청완료 방문예약",
            });
            window.location.href = isExternalUrl(
              `${HOSTNAME}/booking/hall${searchParams}&inpath=ETC&origin=notiapp&hidetop=true`,
            );
          }}
        >
          방문 예약 신청
        </button>
      </div>
    </div>
  );
};

export default WeeklyAlarmComplete;
